import ProgressInfoDescription from './ProgressInfoDescription';

export default ProgressInfoDescription;
